import React, { useMemo, useState } from "react";
import { match } from "ts-pattern";
import { useQuery } from "react-query";
import { getUnderClubCompanies } from "ui-io/queries/get-under-club-companies";
import { CenterSpinner, ErrorState, useToggle, NoData, CustomCard, TitleComponent } from "ui-components";
import FounderTableView, { CompanyT } from "./table";
import CompanyDetails from "../company/details";

const FounderTable: React.FC = () => {
  const [currentCompany, setCurrentComapny] = useState<any>();
  const [isCompanyDetail, setToggleCompanyDetail] = useToggle(false);

  const connection = useQuery(
    getUnderClubCompanies({ date: "17/12/2024" })
  );
  
  const companies: CompanyT[] = useMemo(() => {
    if (!connection?.data?.length) {
      return [];
    }

    return connection.data.map((company: any) => {
      const latestFunding = company?.funding_rounds?.at(-1);

      const address: any =
        company?.address?.length &&
        company.address.find(
          (i: Record<string, string>) => i.type === "REGISTERED" || i.type === "HEADQUATER"
        );
      let management =company.management;


      return {
        companyID: company.companyID,
        name: management?.length ? management[0].name : company.name,
        profileImage: management?.length ? management[0].profileImage:"",
        foundersHighlights: company.heighlights,
        companyName: company.name,
        industry: company?.industry?.industry,
        location: address?.country || "",
        relevancyScore: company?.relevancyScore || "80%",
        companyHouseNo: company.licence_no,
      };
    });
  }, [connection.data]);

  const handleCompanyDetails = (company: any) => {
    setCurrentComapny(company);
    setToggleCompanyDetail();
  };

  return (
    <div className={"w-100"}>
      <CompanyDetails
        isCompanyDetail={isCompanyDetail}
        setToggleCompanyDetail={setToggleCompanyDetail}
        currentCompany={currentCompany}
      />
      <CustomCard minHeight="350px">
        <TitleComponent className="fs-lg ml-xs">
        25 & Under Club
        </TitleComponent>
        {match(connection)
          .with({ status: "loading" }, { status: "idle" }, () => (
            <CenterSpinner />
          ))
          .with({ status: "error" }, ({ error }) => (
            <ErrorState error={error} />
          ))
          .with({ status: "success" }, ({ data }) =>
            data?.length === 0 ? (
              <NoData/>
            ) : (
              <FounderTableView
                handleCompanyDetails={handleCompanyDetails}
                companyData={companies}
                isStickyFirstColumn={false}
              />
            )
          )
          .exhaustive()}
      </CustomCard>
    </div>
  );
};

export default FounderTable;

